<!-- <table class="table align-middle mb-0 bg-white content_inner">
    <thead class="bg-light">
        <th>Título</th>
        <th>Descripcion</th>
        <th>Visible</th>
        <th>Programar activo</th>
        <th>Programar inactivo</th>
        <th></th>
    </thead>
    <tbody>
        <tr *ngFor="let listado of Listado">
            <td class="mat-column-titulo">{{ listado.titulo }}</td>
            <td class="mat-column-descripcion">{{ listado.cuerpo }}</td>
            <td *ngIf="listado.visible == true" class="mat-column-visible">
                <mat-checkbox [checked]=true (change)="updateAvisos(listado.id)"></mat-checkbox>
            </td>
            <td *ngIf="listado.visible == false" class="mat-column-visible">
                <mat-checkbox [checked]=false (change)="updateAvisos(listado.id)"></mat-checkbox>
            </td>
            <td class="mat-column-fecha">
                <form [formGroup]="formFechaApertura" (ngSubmit)="updateAperturaAvisos(listado.id)">
                    <div *ngIf="listado.fechaApertura != null">
                        <input
                            placeholder="{{('0'+listado.fechaApertura[2]) | slice:-2}}/{{('0'+listado.fechaApertura[1]) | slice:-2}}/{{('0'+listado.fechaApertura[0]) | slice:-4}}"
                            type="text" onfocus="(this.type='date')"
                            onblur="if(this.value==''){this.type='text'}else this.type='date' "
                            class="mb-2 textbox-n d-block widthDate" formControlName="fecha">
                        <input placeholder="{{('0'+listado.fechaApertura[3]) | slice:-2}}:{{('0'+listado.fechaApertura[4]) | slice:-2}}" type="text"
                            onfocus="(this.type='time')" onblur="(this.type='text')" class="textbox-n d-block widthTime"
                            formControlName="hora">
                    </div>
                    <div *ngIf="listado.fechaApertura == null">
                        <input type="date" formControlName="fecha" class="d-block mb-2">
                        <input type="time" formControlName="hora" class="d-block">
                    </div>
                    <button type="submit" class="mt-2 btn btn-primary m-left">Guardar</button>
                </form>
            </td>
            <td class="mat-column-fecha">
                <form [formGroup]="formFechaCierre" (ngSubmit)="updateCierreAvisos(listado.id)">
                    <div *ngIf="listado.fechaCierre != null">
                        <input
                            placeholder="{{('0'+listado.fechaCierre[2]) | slice:-2}}/{{('0'+listado.fechaCierre[1]) | slice:-2}}/{{('0'+listado.fechaCierre[0]) | slice:-4}}"
                            class="textbox-n w-25" type="text" onfocus="(this.type='date')"
                            onblur="if(this.value==''){this.type='text'}else this.type='date'"
                            class="mb-2 textbox-n d-block widthDate" formControlName="fecha">
                        <input placeholder="{{('0'+listado.fechaCierre[3]) | slice:-2}}:{{('0'+listado.fechaCierre[4]) | slice:-2}}"
                            class="textbox-n w-25" type="text" onfocus="(this.type='time')" onblur="(this.type='text')"
                            class="textbox-n d-block widthTime" formControlName="hora">
                    </div>
                    <div *ngIf="listado.fechaCierre == null">
                        <input type="date" formControlName="fecha" class="d-block mb-2">
                        <input type="time" formControlName="hora" class="d-block">
                    </div>
                    <button type="submit" class="mt-2 btn btn-primary m-left">Guardar</button>
                </form>
            </td>
            <td>
                <div class="table-button-row">
                    <div class="buttons-flex-container">
                        <a class="eye-button activated" (click)="openDialog(listado)"></a>
                        <a class="save-button not-activated"></a>
                        <a class="delete-button activated" (click)="openDeleteDialog(listado.id)"></a>
                        <a class="refresh-button not-activated"></a>
                        <a class="export-button not-activated"></a>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</table> -->

<div>
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" matSort class="table align-middle mb-0 bg-white">
        <!-- Position Column -->
        <ng-container matColumnDef="titulo" class="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by titulo"class="header">{{ 'AVISOS.COL_TITLE' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="mat-column-titulo" style="padding-top: 1%;width: 20%;"> {{element.titulo}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="cuerpo">
            <th class="asuntoNombre" mat-header-cell *matHeaderCellDef mat-sort-header
                sortActionDescription="Sort by cuerpo" class="header"> {{ 'AVISOS.COL_DESC' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="mat-column-descripcion" style="padding-top: 1%;">{{element.cuerpo}}</td>
        </ng-container>

        <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef class="mat-column-visible header">{{ 'AVISOS.COL_STATUS' | translate }}</th>
            <td mat-cell *matCellDef="let element" class="mat-column-visible" style="padding-top: 1%;">
                <button class="asuntoActivo" *ngIf="element.visible">&nbsp;{{ 'COMMON.ACTIVE' | translate }}&nbsp;</button>
                <button class="asuntoInactivo" *ngIf="!element.visible">{{ 'COMMON.INACTIVE' | translate }}</button>
            </td>
        </ng-container>

        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="header"></th>
            <td mat-cell *matCellDef="let element" class="mat-column" style="padding-top: 1%; width: 15%;">
                <div class="buttons-flex-container ">
                    <a class="eye-button activated" (click)="openDialog(element)"></a>
                    <a class="save-button not-activated"></a>
                    <a class="delete-button activated" (click)="openDeleteDialog(element)"></a>
                    <a class="refresh-button not-activated"></a>
                    <a class="export-button not-activated"></a>
                </div>
            </td>
        </ng-container>



        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No se encontro el nombre "{{input.value}}"</td>
        </tr> -->
    </table>
  </div>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="5" showFirstLastButtons style="padding: 15px;">
    </mat-paginator>
</div>